export const cx = (...args: any) => args.reduce((p: any, c: any) => (c ? p + " " + c : p), "");

export const randomInteger = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
